export default __webpack_public_path__ + "static/media/quote-open-outline.185fa83d.svg";